function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _ from 'lodash';
import { PurchaseLimitType, TYPE_MAP_KEY_BY_PURCHASE_LIMIT_TYPE } from 'shared/core/constants/compliance';
import { canadianProvincesMap } from 'shared/core/constants/geography';
import { getComplianceConfig } from 'shared/core/helpers/compliance';
import { MILLIGRAMS_PER_GRAM, GRAMS_PER_OUNCE, FLOWER_TYPES, COMBINED_INHALABLE_TYPES, CONCENTRATE_TYPES, EDIBLE_TYPES, TINCTURE_TYPES, TOPICAL_TYPES, WEIGHTED_TYPES, MILLILITERS_PER_OZ, SUPPORTED_PURCHASE_LIMIT_TYPE_OVERRIDES } from './constants';
/**
 * Returns the jurisdiction limits for a customer, preferring out-of-state limits when applicable.
/**
 * Moves a jurisdiction's combined-inhalable subcategories out of their legacy bucket.
 * The compliance config deliberately keeps those subcategories listed under the legacy
 * Concentrate bucket as well, so engines that do not know the CombinedInhalable bucket
 * (for example after a code-only rollback while an updated remote config is already
 * deployed) still meter them against the legacy cap instead of leaving them unmetered.
 * This normalization performs the move at load time, only while the CombinedInhalable cap
 * is configured for both medical and recreational customers, and seeds the inverse
 * Concentrate ignore entries so members of the combined bucket never consume both caps.
 * A partially configured bucket degrades to legacy routing rather than unmetered products.
 * @param {object} limits raw jurisdiction limits
 * @returns {object} normalized limits, or the same object when no combined bucket is active
 */ var applyCombinedInhalableNormalization = function(limits) {
    var _limits_typeMap_CombinedInhalable, _limits_typeMap, _limits_typeMap_CombinedInhalable1, _limits_typeMap1, _limits_typeMap_Concentrate, _limits_typeMap2, _limits_typeMap_Concentrate1, _limits_typeMap3, _limits_ignoreTypeMap_Concentrate, _limits_ignoreTypeMap, _limits_ignoreTypeMap_Concentrate1, _limits_ignoreTypeMap1;
    var combinedCap = limits === null || limits === void 0 ? void 0 : limits.CombinedInhalable;
    var _limits_typeMap_CombinedInhalable_categories;
    var combinedCategories = (_limits_typeMap_CombinedInhalable_categories = limits === null || limits === void 0 ? void 0 : (_limits_typeMap = limits.typeMap) === null || _limits_typeMap === void 0 ? void 0 : (_limits_typeMap_CombinedInhalable = _limits_typeMap.CombinedInhalable) === null || _limits_typeMap_CombinedInhalable === void 0 ? void 0 : _limits_typeMap_CombinedInhalable.categories) !== null && _limits_typeMap_CombinedInhalable_categories !== void 0 ? _limits_typeMap_CombinedInhalable_categories : [];
    var _limits_typeMap_CombinedInhalable_subcategories;
    var combinedSubcategories = (_limits_typeMap_CombinedInhalable_subcategories = limits === null || limits === void 0 ? void 0 : (_limits_typeMap1 = limits.typeMap) === null || _limits_typeMap1 === void 0 ? void 0 : (_limits_typeMap_CombinedInhalable1 = _limits_typeMap1.CombinedInhalable) === null || _limits_typeMap_CombinedInhalable1 === void 0 ? void 0 : _limits_typeMap_CombinedInhalable1.subcategories) !== null && _limits_typeMap_CombinedInhalable_subcategories !== void 0 ? _limits_typeMap_CombinedInhalable_subcategories : [];
    var combinedIsConfigured = (combinedSubcategories.length > 0 || combinedCategories.length > 0) && (combinedCap === null || combinedCap === void 0 ? void 0 : combinedCap.medical) > 0 && (combinedCap === null || combinedCap === void 0 ? void 0 : combinedCap.rec) > 0;
    if (!combinedIsConfigured) return limits;
    var _limits_typeMap_Concentrate_categories;
    var concentrateCategories = (_limits_typeMap_Concentrate_categories = limits === null || limits === void 0 ? void 0 : (_limits_typeMap2 = limits.typeMap) === null || _limits_typeMap2 === void 0 ? void 0 : (_limits_typeMap_Concentrate = _limits_typeMap2.Concentrate) === null || _limits_typeMap_Concentrate === void 0 ? void 0 : _limits_typeMap_Concentrate.categories) !== null && _limits_typeMap_Concentrate_categories !== void 0 ? _limits_typeMap_Concentrate_categories : [];
    var _limits_typeMap_Concentrate_subcategories;
    var concentrateSubcategories = (_limits_typeMap_Concentrate_subcategories = limits === null || limits === void 0 ? void 0 : (_limits_typeMap3 = limits.typeMap) === null || _limits_typeMap3 === void 0 ? void 0 : (_limits_typeMap_Concentrate1 = _limits_typeMap3.Concentrate) === null || _limits_typeMap_Concentrate1 === void 0 ? void 0 : _limits_typeMap_Concentrate1.subcategories) !== null && _limits_typeMap_Concentrate_subcategories !== void 0 ? _limits_typeMap_Concentrate_subcategories : [];
    var _limits_ignoreTypeMap_Concentrate_categories;
    var ignoredConcentrateCategories = (_limits_ignoreTypeMap_Concentrate_categories = limits === null || limits === void 0 ? void 0 : (_limits_ignoreTypeMap = limits.ignoreTypeMap) === null || _limits_ignoreTypeMap === void 0 ? void 0 : (_limits_ignoreTypeMap_Concentrate = _limits_ignoreTypeMap.Concentrate) === null || _limits_ignoreTypeMap_Concentrate === void 0 ? void 0 : _limits_ignoreTypeMap_Concentrate.categories) !== null && _limits_ignoreTypeMap_Concentrate_categories !== void 0 ? _limits_ignoreTypeMap_Concentrate_categories : [];
    var _limits_ignoreTypeMap_Concentrate_subcategories;
    var ignoredConcentrateSubcategories = (_limits_ignoreTypeMap_Concentrate_subcategories = limits === null || limits === void 0 ? void 0 : (_limits_ignoreTypeMap1 = limits.ignoreTypeMap) === null || _limits_ignoreTypeMap1 === void 0 ? void 0 : (_limits_ignoreTypeMap_Concentrate1 = _limits_ignoreTypeMap1.Concentrate) === null || _limits_ignoreTypeMap_Concentrate1 === void 0 ? void 0 : _limits_ignoreTypeMap_Concentrate1.subcategories) !== null && _limits_ignoreTypeMap_Concentrate_subcategories !== void 0 ? _limits_ignoreTypeMap_Concentrate_subcategories : [];
    // Empty keys are omitted, not written as empty arrays: consumers fall back to their built-in
    // type defaults (for example CONCENTRATE_TYPES) only when a key is absent, and a config that
    // maps an entire bucket away must still meter that bucket's default members.
    var omitEmpty = function(mapping) {
        var entries = _.omitBy(mapping, function(values) {
            return values.length === 0;
        });
        return _.isEmpty(entries) ? undefined : entries;
    };
    var normalizedConcentrate = omitEmpty({
        categories: concentrateCategories.filter(function(category) {
            return !combinedCategories.includes(category);
        }),
        subcategories: concentrateSubcategories.filter(function(subcategory) {
            return !combinedSubcategories.includes(subcategory);
        })
    });
    var normalizedConcentrateIgnore = omitEmpty({
        categories: _.uniq(_to_consumable_array(ignoredConcentrateCategories).concat(_to_consumable_array(combinedCategories))),
        subcategories: _.uniq(_to_consumable_array(ignoredConcentrateSubcategories).concat(_to_consumable_array(combinedSubcategories)))
    });
    return _object_spread_props(_object_spread({}, limits), {
        typeMap: normalizedConcentrate ? _object_spread_props(_object_spread({}, limits.typeMap), {
            Concentrate: normalizedConcentrate
        }) : _.omit(limits.typeMap, 'Concentrate'),
        ignoreTypeMap: normalizedConcentrateIgnore ? _object_spread_props(_object_spread({}, limits.ignoreTypeMap), {
            Concentrate: normalizedConcentrateIgnore
        }) : limits.ignoreTypeMap
    });
};
/**
 * @param {string=} dispensaryState dispensary jurisdiction code
 * @param {string=} customerState customer's jurisdiction code
 * @returns {object} effective static compliance limits
 */ export var getStateLimits = function(dispensaryState, customerState) {
    var outOfStateLimits = getComplianceConfig(dispensaryState, 'outOfStateLimits');
    var limits = getComplianceConfig(dispensaryState, 'limits');
    if (outOfStateLimits && dispensaryState && customerState && dispensaryState !== customerState) {
        limits = outOfStateLimits;
    }
    return applyCombinedInhalableNormalization(limits);
};
/**
 * Selects medical or recreational caps from an effective cart limits object.
 * Missing or zero caps are treated as unlimited to preserve legacy behavior.
 * @param {object} cart serialized compliance cart containing limits and medical status
 * @returns {object} normalized caps consumed by individual limit checkers
 */ export var getTypeLimits = function(cart) {
    var _limits_Flower, _limits_Concentrate, _limits_CombinedInhalable, _limits_EdibleTHC, _limits_TinctureTHC, _limits_TopicalTHC, _limits_SolidEdibleNetWeight, _limits_LiquidEdibleVolumeInOunces, _limits_nonFlower;
    var limits = cart.limits, medical = cart.medical;
    var key = medical ? 'medical' : 'rec';
    var flowerLimit = ((_limits_Flower = limits.Flower) === null || _limits_Flower === void 0 ? void 0 : _limits_Flower[key]) || Infinity;
    var concentrateLimit = ((_limits_Concentrate = limits.Concentrate) === null || _limits_Concentrate === void 0 ? void 0 : _limits_Concentrate[key]) || Infinity;
    var combinedInhalableLimit = ((_limits_CombinedInhalable = limits.CombinedInhalable) === null || _limits_CombinedInhalable === void 0 ? void 0 : _limits_CombinedInhalable[key]) || Infinity;
    var edibleTHCLimit = ((_limits_EdibleTHC = limits.EdibleTHC) === null || _limits_EdibleTHC === void 0 ? void 0 : _limits_EdibleTHC[key]) || Infinity;
    var tinctureLimit = ((_limits_TinctureTHC = limits.TinctureTHC) === null || _limits_TinctureTHC === void 0 ? void 0 : _limits_TinctureTHC[key]) || Infinity;
    var topicalLimit = ((_limits_TopicalTHC = limits.TopicalTHC) === null || _limits_TopicalTHC === void 0 ? void 0 : _limits_TopicalTHC[key]) || Infinity;
    var solidEdibleNetWeightLimit = ((_limits_SolidEdibleNetWeight = limits.SolidEdibleNetWeight) === null || _limits_SolidEdibleNetWeight === void 0 ? void 0 : _limits_SolidEdibleNetWeight[key]) || Infinity;
    var liquidEdibleVolumeLimitInOunces = ((_limits_LiquidEdibleVolumeInOunces = limits.LiquidEdibleVolumeInOunces) === null || _limits_LiquidEdibleVolumeInOunces === void 0 ? void 0 : _limits_LiquidEdibleVolumeInOunces[key]) || Infinity;
    var nonFlowerLimit = ((_limits_nonFlower = limits.nonFlower) === null || _limits_nonFlower === void 0 ? void 0 : _limits_nonFlower[key]) || Infinity;
    var ignoreEdibleLimit = limits.ignoreEdibleLimit || false;
    return {
        flowerLimit: flowerLimit,
        concentrateLimit: concentrateLimit,
        combinedInhalableLimit: combinedInhalableLimit,
        edibleTHCLimit: edibleTHCLimit,
        tinctureLimit: tinctureLimit,
        topicalLimit: topicalLimit,
        solidEdibleNetWeightLimit: solidEdibleNetWeightLimit,
        liquidEdibleVolumeLimitInOunces: liquidEdibleVolumeLimitInOunces,
        nonFlowerLimit: nonFlowerLimit,
        ignoreEdibleLimit: ignoreEdibleLimit
    };
};
/**
 * Resolves a flat or medical/recreational multiplier to the active numeric value.
 * @param {number|object} multiplier flat value or object containing med and rec values
 * @param {boolean} medical whether to select the medical value
 * @returns {number} active multiplier, or zero when missing/falsy
 */ export var resolveMultiplier = function(multiplier, medical) {
    return (_.isPlainObject(multiplier) ? multiplier[medical ? 'med' : 'rec'] : multiplier) || 0;
};
/**
 * Returns the direct Flower-equivalency multiplier for a purchase-limit type override.
 * Physical-form fallback multipliers are intentionally handled separately.
 * @param {string} purchaseLimitTypeOverride configured purchase-limit type override
 * @param {object} limits effective compliance limits
 * @param {boolean} medical whether medical rules apply
 * @returns {number} active direct multiplier, or zero when unsupported/unconfigured
 */ export var getPurchaseLimitTypeOverrideMultiplier = function(purchaseLimitTypeOverride, limits, medical) {
    var _obj;
    var multiplierByType = (_obj = {}, _define_property(_obj, PurchaseLimitType.concentrate, limits.concentrateMultiplier), _define_property(_obj, PurchaseLimitType.edibleTHC, limits.edibleMultiplier), _define_property(_obj, PurchaseLimitType.tinctureTHC, limits.tinctureMultiplier), _define_property(_obj, PurchaseLimitType.topicalTHC, limits.topicalMultiplier), _obj);
    return resolveMultiplier(multiplierByType[purchaseLimitTypeOverride], medical);
};
/**
 * Returns the solid-net-weight or liquid-volume multiplier for a product's physical form.
 * @param {string} productType storefront product type
 * @param {string[]} subcategories effective product subcategories
 * @param {object} limits effective compliance limits
 * @param {boolean} medical whether medical rules apply
 * @returns {number} active physical-form multiplier, or zero when no physical rule applies
 */ export var getPhysicalFormMultiplier = function(productType, subcategories, limits, medical) {
    if (limits.usesSolidEdibleTypes && isSolidEdibleTypeProduct(productType, subcategories)) {
        return resolveMultiplier(limits.solidNetWeightMultiplier, medical);
    }
    if (limits.usesLiquidTypes && isLiquidTypeProduct(limits, productType, subcategories)) {
        return resolveMultiplier(limits.liquidNetWeightMultiplier, medical);
    }
    return 0;
};
/**
 * Reports whether a product's purchase-limit type override has a real enforcing cap.
 * Enforcement may come from a finite direct cap or from a finite Flower-equivalency path with a
 * positive purchase-limit-type or physical-form multiplier.
 * @param {object} product serialized cart product
 * @param {object} context effective limits, medical status, and subcategory mode
 * @returns {boolean} whether physical-form checks can safely avoid double-counting this product
 */ export var isPurchaseLimitTypeOverrideEnforced = function(product) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_limits = _ref.limits, limits = _ref_limits === void 0 ? {} : _ref_limits, _ref_medical = _ref.medical, medical = _ref_medical === void 0 ? false : _ref_medical, _ref_useMultiSubcategories = _ref.useMultiSubcategories, useMultiSubcategories = _ref_useMultiSubcategories === void 0 ? false : _ref_useMultiSubcategories;
    if (!product.purchaseLimitTypeOverride) return false;
    var typeLimits = getTypeLimits({
        limits: limits,
        medical: medical
    });
    var _obj;
    var limitByPurchaseLimitType = (_obj = {}, _define_property(_obj, PurchaseLimitType.flower, typeLimits.flowerLimit), _define_property(_obj, PurchaseLimitType.concentrate, typeLimits.concentrateLimit), _define_property(_obj, PurchaseLimitType.edibleTHC, typeLimits.edibleTHCLimit), _define_property(_obj, PurchaseLimitType.tinctureTHC, typeLimits.tinctureLimit), _define_property(_obj, PurchaseLimitType.topicalTHC, typeLimits.topicalLimit), _obj);
    var purchaseLimitTypeOverrideIsIgnored = product.purchaseLimitTypeOverride === PurchaseLimitType.edibleTHC && typeLimits.ignoreEdibleLimit;
    if (!purchaseLimitTypeOverrideIsIgnored && Number.isFinite(limitByPurchaseLimitType[product.purchaseLimitTypeOverride])) return true;
    var combinesIntoFlower = medical ? limits.medUsesEquivalencyCalculator : limits.usesEquivalencyCalculator;
    var purchaseLimitTypeMultiplier = getPurchaseLimitTypeOverrideMultiplier(product.purchaseLimitTypeOverride, limits, medical);
    var subcategories = getEffectiveSubcategories(product, useMultiSubcategories);
    var physicalFormMultiplier = getPhysicalFormMultiplier(product.type, subcategories, limits, medical);
    return Boolean(combinesIntoFlower && Number.isFinite(typeLimits.flowerLimit) && (purchaseLimitTypeMultiplier > 0 || physicalFormMultiplier > 0));
};
/** @returns {boolean} whether the storefront product type belongs to the Flower family. */ export var isFlower = function(type) {
    return _.includes(FLOWER_TYPES, type);
};
/** @returns {boolean} whether the storefront product type belongs to the Concentrate family. */ export var isConcentrate = function(type) {
    return _.includes(CONCENTRATE_TYPES, type);
};
/** @returns {boolean} whether the storefront product type belongs to the Edible family. */ export var isEdible = function(type) {
    return _.includes(EDIBLE_TYPES, type);
};
/** @returns {boolean} whether the storefront product type belongs to the Tincture family. */ export var isTincture = function(type) {
    return _.includes(TINCTURE_TYPES, type);
};
/** @returns {boolean} whether the storefront product type belongs to the Topical family. */ export var isTopical = function(type) {
    return _.includes(TOPICAL_TYPES, type);
};
/** @returns {boolean} whether the product uses weight-based option accounting. */ export var isWeightedProduct = function(param) {
    var type = param.type;
    return _.includes(WEIGHTED_TYPES, type);
};
/**
 * Resolves the subcategories used by compliance classification under the multi-subcategory rollout.
 * @param {object} product product containing singular and/or plural subcategory fields
 * @param {boolean} useMultiSubcategories whether populated plural subcategories are authoritative
 * @returns {string[]} effective subcategories, excluding empty values
 */ export var getEffectiveSubcategories = function() {
    var product = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, useMultiSubcategories = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var subcategory = product.subcategory, subcategories = product.subcategories;
    if (useMultiSubcategories && (subcategories === null || subcategories === void 0 ? void 0 : subcategories.length)) {
        return subcategories;
    }
    return _.compact([
        subcategory
    ]);
};
/**
 * Resolves a customer mapping for one product, preferring an exact subcategory match over a
 * category-wide fallback.
 * @param {object} product product to classify
 * @param {object[]} categoryMappings sanitized customer category mappings
 * @param {boolean} useMultiSubcategories whether plural subcategories are authoritative
 * @returns {string|null} mapped purchase-limit type, or null when no mapping applies
 */ export var getMappedPurchaseLimitType = function(product) {
    var categoryMappings = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], useMultiSubcategories = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var _matchingMappings_find;
    if (!product || !_.isArray(categoryMappings)) return null;
    var subcategories = getEffectiveSubcategories(product, useMultiSubcategories);
    var matchingMappings = categoryMappings.filter(function(mapping) {
        return mapping.category === product.type;
    });
    var exactMatch = matchingMappings.find(function(mapping) {
        return mapping.subcategory && _.includes(subcategories, mapping.subcategory);
    });
    var _exactMatch_purchaseLimitType, _ref;
    return (_ref = (_exactMatch_purchaseLimitType = exactMatch === null || exactMatch === void 0 ? void 0 : exactMatch.purchaseLimitType) !== null && _exactMatch_purchaseLimitType !== void 0 ? _exactMatch_purchaseLimitType : (_matchingMappings_find = matchingMappings.find(function(mapping) {
        return !mapping.subcategory;
    })) === null || _matchingMappings_find === void 0 ? void 0 : _matchingMappings_find.purchaseLimitType) !== null && _ref !== void 0 ? _ref : null;
};
/**
 * Validates and deduplicates customer category mappings at the persisted configuration boundary.
 * The first mapping for each source category/subcategory pair wins.
 * @param {unknown} categoryMappings untrusted stored mapping configuration
 * @returns {object[]} normalized mappings with supported purchase-limit types
 */ export var sanitizeCategoryMappings = function(categoryMappings) {
    return _.uniqBy(_.filter(_.isArray(categoryMappings) ? categoryMappings : [], function(mapping) {
        var validSubcategory = (mapping === null || mapping === void 0 ? void 0 : mapping.subcategory) == null || _.isString(mapping.subcategory);
        return _.isString(mapping === null || mapping === void 0 ? void 0 : mapping.category) && mapping.category.length > 0 && validSubcategory && _.includes(SUPPORTED_PURCHASE_LIMIT_TYPE_OVERRIDES, mapping === null || mapping === void 0 ? void 0 : mapping.purchaseLimitType);
    }).map(function(param) {
        var category = param.category, subcategory = param.subcategory, purchaseLimitType = param.purchaseLimitType;
        return _object_spread_props(_object_spread({
            category: category
        }, subcategory ? {
            subcategory: subcategory
        } : {}), {
            purchaseLimitType: purchaseLimitType
        });
    }), function(param) {
        var category = param.category, subcategory = param.subcategory;
        return "".concat(category, ":").concat(subcategory !== null && subcategory !== void 0 ? subcategory : '');
    });
};
/**
 * Validates and deduplicates removals of Dutchie static purchase-limit assignments.
 * @param {unknown} exclusions untrusted stored exclusion configuration
 * @returns {object[]} normalized exclusions keyed by purchase-limit type and source
 */ export var sanitizeCategoryMappingExclusions = function(exclusions) {
    return _.uniqBy(_.filter(_.isArray(exclusions) ? exclusions : [], function(exclusion) {
        var validCategory = (exclusion === null || exclusion === void 0 ? void 0 : exclusion.category) == null || _.isString(exclusion.category);
        var validSubcategory = (exclusion === null || exclusion === void 0 ? void 0 : exclusion.subcategory) == null || _.isString(exclusion.subcategory);
        return _.includes(SUPPORTED_PURCHASE_LIMIT_TYPE_OVERRIDES, exclusion === null || exclusion === void 0 ? void 0 : exclusion.purchaseLimitType) && validCategory && validSubcategory && (exclusion.category || exclusion.subcategory);
    }).map(function(param) {
        var category = param.category, subcategory = param.subcategory, purchaseLimitType = param.purchaseLimitType;
        return _object_spread_props(_object_spread({}, category ? {
            category: category
        } : {}, subcategory ? {
            subcategory: subcategory
        } : {}), {
            purchaseLimitType: purchaseLimitType
        });
    }), function(param) {
        var category = param.category, subcategory = param.subcategory, purchaseLimitType = param.purchaseLimitType;
        return "".concat(purchaseLimitType, ":").concat(category !== null && category !== void 0 ? category : '', ":").concat(subcategory !== null && subcategory !== void 0 ? subcategory : '');
    });
};
/**
 * Attaches sanitized assignment exclusions to an effective limits object without mutating it.
 * @param {object} limits merged compliance limits
 * @param {object[]} exclusions sanitized assignment exclusions
 * @returns {object} limits containing the exclusions used during classification
 */ export var applyCategoryMappingExclusions = function(limits, exclusions) {
    return _object_spread_props(_object_spread({}, limits), {
        categoryMappingExclusions: exclusions
    });
};
/**
 * Builds the stable key used to exchange resolved purchase-limit classifications between checks.
 * Product IDs are preferred; products without IDs use a deterministic category/subcategory key.
 * @param {object} product product to identify
 * @returns {string} product ID, Mongo ID, or composite fallback key
 */ export var getProductLimitTypeKey = function() {
    var product = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _product_id, _product_subcategory, _product_subcategories, _ref;
    return (_ref = (_product_id = product.id) !== null && _product_id !== void 0 ? _product_id : product._id) !== null && _ref !== void 0 ? _ref : "".concat(product.type, ":").concat((_product_subcategory = product.subcategory) !== null && _product_subcategory !== void 0 ? _product_subcategory : '', ":").concat(((_product_subcategories = product.subcategories) !== null && _product_subcategories !== void 0 ? _product_subcategories : []).join('|'));
};
/**
 * Reports whether a category or subcategory is configured as a liquid edible type.
 * @param {object} limits effective compliance limits
 * @param {string} type storefront product type
 * @param {string[]} subcategories effective product subcategories
 * @returns {boolean} whether liquid-volume accounting applies
 */ export var isLiquidTypeProduct = function(limits, type) {
    var subcategories = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var _limits_liquidEdibleTypes, _limits_liquidEdibleTypes1;
    var _limits_liquidEdibleTypes_categories;
    var liquidCategories = (_limits_liquidEdibleTypes_categories = (_limits_liquidEdibleTypes = limits.liquidEdibleTypes) === null || _limits_liquidEdibleTypes === void 0 ? void 0 : _limits_liquidEdibleTypes.categories) !== null && _limits_liquidEdibleTypes_categories !== void 0 ? _limits_liquidEdibleTypes_categories : [];
    var _limits_liquidEdibleTypes_subcategories;
    var liquidSubcategories = (_limits_liquidEdibleTypes_subcategories = (_limits_liquidEdibleTypes1 = limits.liquidEdibleTypes) === null || _limits_liquidEdibleTypes1 === void 0 ? void 0 : _limits_liquidEdibleTypes1.subcategories) !== null && _limits_liquidEdibleTypes_subcategories !== void 0 ? _limits_liquidEdibleTypes_subcategories : [];
    var liquidTypes = _to_consumable_array(liquidCategories).concat(_to_consumable_array(liquidSubcategories));
    return _.includes(liquidTypes, type) || _.intersection(liquidTypes, subcategories).length > 0;
};
/**
 * Reports whether a product is a non-drink edible subject to solid net-weight accounting.
 * @param {string} type storefront product type
 * @param {string[]} subcategories effective product subcategories
 * @returns {boolean} whether solid-edible accounting applies
 */ export var isSolidEdibleTypeProduct = function(type) {
    var subcategories = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return isEdible(type) && !_.includes(subcategories, 'drinks');
};
/**
 * Reports whether the product matches a customer-saved removal of a Dutchie static assignment.
 *
 * An exclusion may target a source category, a source subcategory, or both. Omitted source fields
 * behave as wildcards. Passing `purchaseLimitType` scopes the match to one purchase-limit type;
 * omitting it matches an exclusion for any purchase-limit type.
 *
 * This helper only matches the saved exclusion record. It does not prove that the product is
 * statically assigned to that purchase-limit type. Callers that need to restore normal source routing
 * must additionally verify the corresponding static typeMap assignment with
 * `isStaticPurchaseLimitAssignmentRemoved`.
 *
 * @param {string} typeFromCartProduct product's original source category
 * @param {string[]} subcategoriesFromCartProduct product's effective source subcategories
 * @param {object} limits effective compliance limits containing categoryMappingExclusions
 * @param {string} [purchaseLimitType] optional purchase-limit type to match
 * @returns {boolean} whether a matching saved exclusion exists
 */ export var hasCategoryMappingExclusion = function() {
    var typeFromCartProduct = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '', subcategoriesFromCartProduct = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], limits = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, purchaseLimitType = arguments.length > 3 ? arguments[3] : void 0;
    return _.some(limits.categoryMappingExclusions, function(param) {
        var category = param.category, subcategory = param.subcategory, excludedPurchaseLimitType = param.purchaseLimitType;
        var purchaseLimitTypeMatches = !purchaseLimitType || purchaseLimitType === excludedPurchaseLimitType;
        var categoryMatches = !category || category === typeFromCartProduct;
        var subcategoryMatches = !subcategory || _.includes(subcategoriesFromCartProduct, subcategory);
        return purchaseLimitTypeMatches && categoryMatches && subcategoryMatches;
    });
};
var isAssignedToPurchaseLimitType = function(typeFromCartProduct, subcategoriesFromCartProduct, limits, purchaseLimitType) {
    var typeMapKey = TYPE_MAP_KEY_BY_PURCHASE_LIMIT_TYPE[purchaseLimitType];
    var categories = _.get(limits, "typeMap.".concat(typeMapKey, ".categories"), []);
    var subcategories = _.get(limits, "typeMap.".concat(typeMapKey, ".subcategories"), []);
    return _.includes(categories, typeFromCartProduct) || _.intersection(subcategories, subcategoriesFromCartProduct).length > 0;
};
/**
 * Reports whether an exclusion removes a real Dutchie static assignment for this product.
 * Unlike hasCategoryMappingExclusion, this verifies that the matching static typeMap assignment
 * actually exists before treating it as removed.
 * @param {string} typeFromCartProduct product's original source category
 * @param {string[]} subcategoriesFromCartProduct product's effective source subcategories
 * @param {object} limits effective compliance limits
 * @returns {boolean} whether a real static purchase-limit assignment was removed
 */ export var isStaticPurchaseLimitAssignmentRemoved = function(typeFromCartProduct, subcategoriesFromCartProduct) {
    var limits = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return _.some(limits.categoryMappingExclusions, function(param) {
        var purchaseLimitType = param.purchaseLimitType;
        return hasCategoryMappingExclusion(typeFromCartProduct, subcategoriesFromCartProduct, limits, purchaseLimitType) && isAssignedToPurchaseLimitType(typeFromCartProduct, subcategoriesFromCartProduct, limits, purchaseLimitType);
    });
};
/**
 * Maps a product's natural storefront type to its default purchase-limit type.
 * @param {object} product product with a storefront type
 * @returns {string|null} default supported purchase-limit type, or null for unsupported products
 */ export var getDefaultPurchaseLimitType = function(product) {
    if (isFlower(product.type)) return PurchaseLimitType.flower;
    if (isConcentrate(product.type)) return PurchaseLimitType.concentrate;
    if (isEdible(product.type)) return PurchaseLimitType.edibleTHC;
    if (isTincture(product.type)) return PurchaseLimitType.tinctureTHC;
    if (isTopical(product.type)) return PurchaseLimitType.topicalTHC;
    return null;
};
/**
 * Reports whether removing a static assignment restores a source classification that is itself enforced.
 * An unenforced restored type must retain the static assignment so an exclusion cannot create an unlimited product.
 */ export var isCategoryMappingExclusionEnforced = function(product) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_limits = _ref.limits, limits = _ref_limits === void 0 ? {} : _ref_limits, _ref_medical = _ref.medical, medical = _ref_medical === void 0 ? false : _ref_medical, _ref_useMultiSubcategories = _ref.useMultiSubcategories, useMultiSubcategories = _ref_useMultiSubcategories === void 0 ? false : _ref_useMultiSubcategories, purchaseLimitType = arguments.length > 2 ? arguments[2] : void 0;
    var subcategories = getEffectiveSubcategories(product, useMultiSubcategories);
    var excludedPurchaseLimitTypes = purchaseLimitType ? [
        purchaseLimitType
    ] : _.map(limits.categoryMappingExclusions, 'purchaseLimitType');
    var removesStaticAssignment = _.some(excludedPurchaseLimitTypes, function(excludedPurchaseLimitType) {
        return hasCategoryMappingExclusion(product.type, subcategories, limits, excludedPurchaseLimitType) && isAssignedToPurchaseLimitType(product.type, subcategories, limits, excludedPurchaseLimitType);
    });
    var defaultPurchaseLimitType = getDefaultPurchaseLimitType(product);
    return Boolean(removesStaticAssignment && defaultPurchaseLimitType && isPurchaseLimitTypeOverrideEnforced(_object_spread_props(_object_spread({}, product), {
        purchaseLimitTypeOverride: defaultPurchaseLimitType
    }), {
        limits: limits,
        medical: medical,
        useMultiSubcategories: useMultiSubcategories
    }));
};
/**
 * Resolves classification for enforced mappings and products with removed static assignments.
 * Unenforced overrides and products following unchanged static routing are omitted so callers use
 * the same legacy typeMap and ignoreTypeMap classification as the limit engine.
 * @param {object} cart serialized cart containing orders, limits, and subcategory mode
 * @returns {object} sparse map of resolved purchase-limit types keyed by stable product key
 */ export var getResolvedPurchaseLimitTypesByProductKey = function(param) {
    var orders = param.orders, limits = param.limits, medical = param.medical, useMultiSubcategories = param.useMultiSubcategories;
    return _.reduce(orders, function(types, param) {
        var product = param.product;
        var enforcementContext = {
            limits: limits,
            medical: medical,
            useMultiSubcategories: useMultiSubcategories
        };
        var defaultPurchaseLimitType = getDefaultPurchaseLimitType(product);
        var defaultTypeAfterAssignmentRemoval = isCategoryMappingExclusionEnforced(product, enforcementContext) ? defaultPurchaseLimitType : null;
        var enforcedPurchaseLimitTypeOverride = isPurchaseLimitTypeOverrideEnforced(product, enforcementContext) ? product.purchaseLimitTypeOverride : null;
        var resolvedPurchaseLimitType = enforcedPurchaseLimitTypeOverride !== null && enforcedPurchaseLimitTypeOverride !== void 0 ? enforcedPurchaseLimitTypeOverride : defaultTypeAfterAssignmentRemoval;
        return resolvedPurchaseLimitType ? _object_spread_props(_object_spread({}, types), _define_property({}, getProductLimitTypeKey(product), resolvedPurchaseLimitType)) : types;
    }, {});
};
/**
 * Returns the active cap for a product's narrowed physical/category type.
 * @param {object} product product to classify
 * @param {object} cart serialized compliance cart
 * @param {boolean} useMultiSubcategories whether plural subcategories are authoritative
 * @returns {number} effective limit, typically finite or Infinity
 */ export var getLimitForType = function(product, cart) {
    var useMultiSubcategories = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var productType = product.type;
    var subcategories = getEffectiveSubcategories(product, useMultiSubcategories);
    var limits = cart.limits;
    var _getTypeLimits = getTypeLimits(cart), flowerLimit = _getTypeLimits.flowerLimit, concentrateLimit = _getTypeLimits.concentrateLimit, combinedInhalableLimit = _getTypeLimits.combinedInhalableLimit, edibleTHCLimit = _getTypeLimits.edibleTHCLimit, tinctureLimit = _getTypeLimits.tinctureLimit, topicalLimit = _getTypeLimits.topicalLimit, solidEdibleNetWeightLimit = _getTypeLimits.solidEdibleNetWeightLimit, liquidEdibleVolumeLimitInOunces = _getTypeLimits.liquidEdibleVolumeLimitInOunces;
    var currentType = narrowProductType(productType, subcategories, limits);
    var typeMap = {
        Flower: flowerLimit,
        Concentrate: concentrateLimit,
        CombinedInhalable: combinedInhalableLimit,
        Edible: limits.usesSolidEdibleTypes ? solidEdibleNetWeightLimit : edibleTHCLimit,
        Tincture: tinctureLimit,
        Topical: topicalLimit,
        Liquid: liquidEdibleVolumeLimitInOunces
    };
    return typeMap[currentType];
};
/**
 * Converts internal product and limit type names to customer-facing plural labels.
 * @param {string} type internal type name
 * @returns {string|undefined} display label when the type is known
 */ export var formatDisplayedType = function(type) {
    var typeMap = {
        Liquid: 'liquids',
        liquids: 'liquids',
        liquid: 'liquids',
        Tincture: 'tinctures',
        tintures: 'tinctures',
        tincture: 'tinctures',
        seeds: 'seeds',
        Edible: 'edibles',
        edibles: 'edibles',
        edible: 'edibles',
        Topical: 'topicals',
        topicals: 'topicals',
        topical: 'topicals',
        Flower: 'flower',
        flower: 'flower',
        'Pre-Rolls': 'flower',
        'pre-rolls': 'flower',
        cannabis: 'cannabis',
        Cannabis: 'cannabis',
        Concentrate: 'concentrates',
        concentrate: 'concentrates',
        Concentrates: 'concentrates',
        concentrates: 'concentrates',
        CombinedInhalable: 'combined inhalable products',
        'combined inhalable products': 'combined inhalable products',
        drinks: 'drinks'
    };
    return typeMap[type];
};
/**
 * Formats a jurisdiction-aware customer message for an exceeded purchase limit.
 * Converts internal grams to mg for THC and Canadian liquid units to liters where required.
 * @param {string} type customer-facing product type label
 * @param {number} limit internal limit value
 * @param {string} state jurisdiction code
 * @param {string} unit requested display unit
 * @returns {string} purchase-limit message
 */ export var getLimitMessage = function(type, limit, state) {
    var unit = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 'g';
    var inCanada = _.has(canadianProvincesMap, state);
    var message = function(msgLimit, msgUnit) {
        return "You've reached the ".concat(msgLimit).concat(msgUnit, " purchase limit for ").concat(type, " due to ").concat(inCanada ? 'federal' : 'state', " regulations.");
    };
    // if unit is milligrams, convert gram limit to milligrams
    if (unit === 'mg') {
        return message(limit *= MILLIGRAMS_PER_GRAM, unit);
    }
    // if Canada, convert oz limit to liters
    if (inCanada && type === 'liquids') {
        return message((limit / GRAMS_PER_OUNCE * MILLILITERS_PER_OZ / 1000).toFixed(1), 'L');
    }
    if (inCanada && type === 'liquid edibles') {
        return message((limit * MILLILITERS_PER_OZ / 1000).toFixed(1), 'L');
    }
    // if converting to oz results in a clean number gte to 1, show ozLimit
    var ozLimit = limit / GRAMS_PER_OUNCE;
    if (Math.round(ozLimit * 100) === ozLimit * 100 && ozLimit >= 1) {
        return message(ozLimit, 'oz');
    }
    return message(limit, unit);
};
/**
 * Narrows a storefront category to the internal category used to select a direct limit.
 * Liquid classification is evaluated before edible classification because it has its own volume cap.
 * @param {string} type storefront product type
 * @param {string[]} subcategories effective product subcategories
 * @param {object} limits effective compliance limits
 * @returns {string} narrowed limit category
 */ export var narrowProductType = function(type) {
    var subcategories = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], limits = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _limits_typeMap_CombinedInhalable, _limits_typeMap, _limits_typeMap_CombinedInhalable1, _limits_typeMap1;
    var _limits_typeMap_CombinedInhalable_categories;
    // A jurisdiction may split inhalable products into a bucket independent of concentrates
    // (Oregon's "cannabinoid products intended for inhalation"); products statically assigned
    // to that bucket resolve to it before their storefront category's default bucket. Only
    // inhalable storefront categories qualify, so a shared subcategory tag on a product from a
    // non-inhalable category cannot resolve to the inhalation bucket.
    var combinedInhalableCategories = (_limits_typeMap_CombinedInhalable_categories = (_limits_typeMap = limits.typeMap) === null || _limits_typeMap === void 0 ? void 0 : (_limits_typeMap_CombinedInhalable = _limits_typeMap.CombinedInhalable) === null || _limits_typeMap_CombinedInhalable === void 0 ? void 0 : _limits_typeMap_CombinedInhalable.categories) !== null && _limits_typeMap_CombinedInhalable_categories !== void 0 ? _limits_typeMap_CombinedInhalable_categories : [];
    var _limits_typeMap_CombinedInhalable_subcategories;
    var combinedInhalableSubcategories = (_limits_typeMap_CombinedInhalable_subcategories = (_limits_typeMap1 = limits.typeMap) === null || _limits_typeMap1 === void 0 ? void 0 : (_limits_typeMap_CombinedInhalable1 = _limits_typeMap1.CombinedInhalable) === null || _limits_typeMap_CombinedInhalable1 === void 0 ? void 0 : _limits_typeMap_CombinedInhalable1.subcategories) !== null && _limits_typeMap_CombinedInhalable_subcategories !== void 0 ? _limits_typeMap_CombinedInhalable_subcategories : [];
    if (_.includes(COMBINED_INHALABLE_TYPES, type) && (_.includes(combinedInhalableCategories, type) || _.intersection(combinedInhalableSubcategories, subcategories).length > 0)) {
        return 'CombinedInhalable';
    }
    if (isFlower(type)) {
        return 'Flower';
    }
    if (isConcentrate(type)) {
        return 'Concentrate';
    }
    if (isLiquidTypeProduct(limits, type, subcategories)) {
        return 'Liquid';
    }
    if (isEdible(type) || isSolidEdibleTypeProduct(type, subcategories)) {
        return 'Edible';
    }
    if (isTincture(type)) {
        return 'Tincture';
    }
    if (isTopical(type)) {
        return 'Topical';
    }
    return type;
};
/**
 * Reports whether one product contributes to an exceeded limit type during cart trimming.
 * Explicit purchase-limit overrides take precedence; otherwise static typeMap and ignoreTypeMap
 * classification for the customer's jurisdiction is used.
 * @param {object} product product being considered for quantity reduction
 * @param {string} type exceeded limit type
 * @param {object} order order context containing dispensary and customer state
 * @param {boolean} useMultiSubcategories whether plural subcategories are authoritative
 * @returns {boolean} whether reducing this product can reduce the exceeded limit
 */ export var productIncludedInType = function(product, type, order) {
    var useMultiSubcategories = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var _dispensary_location, _ignoreTypeMap_type, _ignoreTypeMap_type1, _typeMap_type, _typeMap_type1;
    if (!type || !order) {
        return false;
    }
    var category = product.type, purchaseLimitTypeOverride = product.purchaseLimitTypeOverride;
    if (purchaseLimitTypeOverride) {
        if (type === 'Non-Flower') return purchaseLimitTypeOverride !== PurchaseLimitType.flower;
        return TYPE_MAP_KEY_BY_PURCHASE_LIMIT_TYPE[purchaseLimitTypeOverride] === type;
    }
    var subcategories = getEffectiveSubcategories(product, useMultiSubcategories);
    var customerState = order.customerState, dispensary = order.dispensary;
    var limits = getStateLimits(dispensary === null || dispensary === void 0 ? void 0 : (_dispensary_location = dispensary.location) === null || _dispensary_location === void 0 ? void 0 : _dispensary_location.state, customerState);
    var typeMap = limits.typeMap, ignoreTypeMap = limits.ignoreTypeMap;
    // The combined inhalable bucket only meters products from inhalable storefront categories,
    // so a non-inhalable category sharing a subcategory tag is never trimmed against it.
    if (type === 'CombinedInhalable' && !_.includes(COMBINED_INHALABLE_TYPES, category)) {
        return false;
    }
    var defaultsForType;
    switch(type){
        case 'Flower':
            defaultsForType = FLOWER_TYPES;
            break;
        case 'Concentrate':
            defaultsForType = CONCENTRATE_TYPES;
            break;
        case 'Edible':
            defaultsForType = EDIBLE_TYPES;
            break;
        case 'Tincture':
            defaultsForType = TINCTURE_TYPES;
            break;
        case 'Topicals':
            defaultsForType = TOPICAL_TYPES;
            break;
        default:
            defaultsForType = [
                type
            ];
    }
    var _ignoreTypeMap_type_categories;
    var ignoredCategoriesForType = (_ignoreTypeMap_type_categories = ignoreTypeMap === null || ignoreTypeMap === void 0 ? void 0 : (_ignoreTypeMap_type = ignoreTypeMap[type]) === null || _ignoreTypeMap_type === void 0 ? void 0 : _ignoreTypeMap_type.categories) !== null && _ignoreTypeMap_type_categories !== void 0 ? _ignoreTypeMap_type_categories : [];
    var _ignoreTypeMap_type_subcategories;
    var ignoredSubCategoriesForType = (_ignoreTypeMap_type_subcategories = ignoreTypeMap === null || ignoreTypeMap === void 0 ? void 0 : (_ignoreTypeMap_type1 = ignoreTypeMap[type]) === null || _ignoreTypeMap_type1 === void 0 ? void 0 : _ignoreTypeMap_type1.subcategories) !== null && _ignoreTypeMap_type_subcategories !== void 0 ? _ignoreTypeMap_type_subcategories : [];
    var _typeMap_type_categories;
    var includedCategoriesForType = (_typeMap_type_categories = typeMap === null || typeMap === void 0 ? void 0 : (_typeMap_type = typeMap[type]) === null || _typeMap_type === void 0 ? void 0 : _typeMap_type.categories) !== null && _typeMap_type_categories !== void 0 ? _typeMap_type_categories : [];
    var _typeMap_type_subcategories;
    var includedSubCategoriesForType = (_typeMap_type_subcategories = typeMap === null || typeMap === void 0 ? void 0 : (_typeMap_type1 = typeMap[type]) === null || _typeMap_type1 === void 0 ? void 0 : _typeMap_type1.subcategories) !== null && _typeMap_type_subcategories !== void 0 ? _typeMap_type_subcategories : [];
    // Only returns true if:
    // the product's category OR subcategory is NOT in the ignoreTypeMap overrides for the specified type, and...
    // the product's category OR subcategory is in the typeMap overrides or defaults for the specified type, or...
    // the product's category is the specified type
    var isIgnoredCategory = _.includes(ignoredCategoriesForType, category);
    var isIgnoredSubCategory = _.intersection(ignoredSubCategoriesForType, subcategories).length > 0;
    var isAddedCategory = _.includes(includedCategoriesForType, category);
    var isAddedSubCategory = _.intersection(includedSubCategoriesForType, subcategories).length > 0;
    if (isIgnoredCategory || isIgnoredSubCategory) {
        return false;
    }
    if (category !== type) {
        if (!isAddedCategory && !isAddedSubCategory && !_.includes(defaultsForType, category)) {
            return false;
        }
    }
    return true;
};
